import { Subtitle1, Table, TableBody, TableCell, TableCellLayout, TableHeader, TableHeaderCell, TableRow, Text, Spinner } from '@fluentui/react-components';
import { Pin12Filled, Pin12Regular } from '@fluentui/react-icons';
import React, { useEffect, useState } from 'react';
import { NewsListItem } from '../models/news';
import { PlacementDoc } from '../models/placements';
import { Note } from '../models/note';
import NewsDialog from './dialogs/NewsDialog';
import { getNewsByQuery, markAsRead } from '../services/newsService';
import { getPlacementDocuments, getSupplierPlacementDocuments } from '../services/placementService';
import { useNavigate } from 'react-router-dom';
import { getNote, getNotesByUserModules } from '../services/noteService';
import { useAppContext } from '../AppContext';
import {Module} from '../models/module';
import TenderSettingsDrawer from './TenderSettings/TenderSettingsDrawer';
import { Organization } from '../models/organizations';
import { getTasks } from '../services/taskService';

const StartComponent = () => {
  console.log("start");

  const [news, setNews] = useState<any[]>([]);
  const [selectedNews, setSelectedNews] = useState<NewsListItem>();
  const [newsDialogOpen, setNewsDialogOpen] = useState<boolean>(false);
  const [placements, setPlacements] = useState<any[]>([]);
  const [notes, setNotes] = useState<any[]>([]);
  const [selectedTender, setSelectedTender] = useState<Module>();
  const [isTenderDrawerOpen, setIsTenderDrawerOpen] = useState<boolean>(false);
  const [loadingNews, setLoadingNews] = useState<boolean>(false);
  const [loadingPlacements, setLoadingPlacements] = useState<boolean>(false);
  const [loadingNotes, setLoadingNotes] = useState<boolean>(false);
  const {user, featurePermissions} = useAppContext();

  const navigate = useNavigate();
;
  useEffect(() => {
    const fetchData = async () => {
      setLoadingNews(true);
      setLoadingPlacements(true);
      setLoadingNotes(true);
      const now = new Date().toISOString(); 

      const fetchNews = () =>
        getNewsByQuery({ pageIndex: 1, pageSize: 5, publishDateEnd: now, unpublishDateStart: now }).then((r) => r.news as any[]);

      const fetchPlacements = async (): Promise<any[]> => {
        if (user.roles.some((r: any) => r.roleType == 'General')) {
          const result = await getPlacementDocuments([], [], [], undefined, 0);
          return result.placementDocuments.filter((pd: PlacementDoc) => pd.content.status == 'sent' || pd.content.status == 'search');
        } else if (user.roles.some((r: any) => r.roleType == 'Procurer')) {
          const result = await getPlacementDocuments([], [], [], user.user.userID, 0);
          return result.placementDocuments.filter((pd: PlacementDoc) => pd.content.status == 'sent' || pd.content.status == 'search');
        } else if (user.roles.some((r: any) => r.roleType == 'Supplier')) {
          const tenderIDs = featurePermissions?.filter((fp: any) => fp.action === 'Accept or deny placement request' || fp.action === 'Accept or deny placement request through organization mandate').map((fp: any) => fp.moduleID) || [];
          const result = await getSupplierPlacementDocuments(tenderIDs, 0);
          return result.placementDocuments;
        }
        return [];
      };

      const fetchNotes = () =>
        featurePermissions?.some(fp => fp.action == 'Tender page/Notes')
          ? getNotesByUserModules()
          : Promise.resolve([]);

      // Run all three in parallel — React 18 batches the state updates below into one render
      const [newsRes, placementsRes, notesRes] = await Promise.allSettled([
        fetchNews(),
        fetchPlacements(),
        fetchNotes(),
      ]);

      if (newsRes.status === 'fulfilled') setNews(newsRes.value.filter((n: NewsListItem) => !n.unpublishDate || new Date(n.unpublishDate) > new Date()));
      else console.error('Error fetching news:', newsRes.reason);

      if (placementsRes.status === 'fulfilled') setPlacements(placementsRes.value ?? []);
      else console.error('Error fetching placements:', placementsRes.reason);

      if (notesRes.status === 'fulfilled') setNotes(notesRes.value);
      else console.error('Error fetching notes:', notesRes.reason);

      setLoadingNews(false);
      setLoadingPlacements(false);
      setLoadingNotes(false);
    };

    fetchData();
  }, [user]);

  const status = {
    search: 'Utkast',
    sent: 'Skickad',
    accepted: 'Verksamhet vald'
  };
  const process = {
    auto: 'Massförfrågan',
    manual: 'Enskild förfrågan'
  };

  const openNewsDialog = async (newsItem: NewsListItem) => {
    setSelectedNews(newsItem);
    if(!newsItem.isRead && user){
      await markAsRead(newsItem.newsID, user.user.userID);
      setNews(prevNews => prevNews.map(n => n.newsID === newsItem.newsID ? { ...n, isRead: true } : n));
    }
    setNewsDialogOpen(true);
  }

  const getNoteTenderAndTendering = (moduleID: number): string => {
    const module = user.modules.find((m: Module) => m.moduleID === moduleID);
    if (!module) return '';
    const parentModuleID = module.modulePath.split("_")[2];
    const parentModule = user.modules.find((m: Module) => m.moduleID === +parentModuleID);
    return parentModule ? (module.moduleName + " / " + parentModule.moduleName) : module.moduleName;
  }

  const getTenderName = (tenderID: number): string => {
    const module = user.modules?.find((m: Module) => m.moduleID === tenderID);
    return module?.moduleName ?? '';
  };

  const openTenderDrawer = (moduleID: number) => {
    const module = user.modules.find((m: Module) => m.moduleID === moduleID);
    if(module){
      setSelectedTender(module);
      setIsTenderDrawerOpen(true);
    }
  };

  const navigateToPlacement = (id: string, tenderID: string): void => {
    if(user.roles.some((r: any) => r.roleType == 'Supplier') && !user.organization){
      navigate(`/forfragan?placementID=${id}&tenderID=${tenderID}`);
    }
    else{
      navigate(`/forfragningar/${id}`);
    }

  }

  return (
    <>
    <div className="bg-[#ebebeb]">
      <div className="flex items-center justify-center h-[300px] bg-gradient-to-r from-orange-700 to-yellow-500 rounded-b mx-auto w-full text-white px-4">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl -mt-20">Välkommen till UPPHANDLAT</h1>
          <p className="text-sm mt-5 mx-auto px-6">
            Upphandlat är ett verktyg för avrop från gemensamt upphandlade avtal.
            Verktyget tillhandahålles av Skånes Kommuner och kan användas fritt av de kommuner
            som deltar i de gemensamma upphandlingar och avtal som hanteras i verktyget,
            samt av de leverantörer vars tjänster kan avropas genom verktyget.
          </p>
        </div>
      </div>
      {(loadingNews || loadingPlacements || loadingNotes) && (
        <div className="-mt-10 flex justify-center relative z-10 py-20">
          <Spinner size="huge" label="Laddar..." />
        </div>
      )}
      <div className="-mt-10 flex flex-col lg:flex-row justify-center gap-6 px-4 md:px-6 max-w-[1500px] mx-auto relative z-10">
      {!loadingNews && news.length > 0 && (
      <div className="bg-white rounded shadow-md w-full lg:w-[calc(33.333%-1rem)] lg:flex-none h-[400px] overflow-y-auto p-3">
          <Table arial-label="Default table">
            <TableHeader style={{ height: "50px" }}>
              <TableRow>
                  <TableHeaderCell>
                      <Subtitle1>Nyheter</Subtitle1>
                  </TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {/* loadingNews ? (
                <TableRow>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex justify-center items-center py-8">
                        <Spinner label="Laddar nyheter..." />
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ) : */ news.map(item => (
                <TableRow className='cursor-pointer' onClick={() => {setSelectedNews(item); openNewsDialog(item)}} key={item.newsID}>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex items-center justify-between">
                        <div className='flex flex-col'>
                            <Text className={item.isRead ? "opacity-[60%]" : ""} weight='bold'>{item.header}</Text>
                            <Text>{item.subject}</Text>
                        </div>
                        {item.highlighted && <div className='flex'>
                            <Pin12Regular />
                        </div>}
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </div>
      )}
      {!loadingPlacements && placements.length > 0 && (
      <div className="bg-white rounded shadow-md w-full lg:w-[calc(33.333%-1rem)] lg:flex-none h-[400px] overflow-y-auto p-3">
          <Table arial-label="Default table">
            <TableHeader style={{ height: "50px" }}>
              <TableRow>
                  <TableHeaderCell>
                      <Subtitle1>Förfrågningar</Subtitle1>
                  </TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {/* loadingPlacements ? (
                <TableRow>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex justify-center items-center py-8">
                        <Spinner label="Laddar förfrågningar..." />
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ) : */ placements.map(item => (
                <TableRow onClick={() => navigateToPlacement(item.placementDocumentID, item.content.tenderID)} className='cursor-pointer' key={item.placementDocumentID}>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex items-center justify-between">
                          <div className='flex flex-col'>
                              <Text weight='bold'>{item.content.reference} {item.content.name}{user.roles.some((r: any) => r.roleType === 'Supplier') && item.content.tenderID ? ` — ${getTenderName(item.content.tenderID)}` : ''}</Text>
                              <Text>{process[item.content.process as keyof typeof process]} {status[item.content.status as keyof typeof status]}</Text>
                          </div>
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </div>
      )}
      {!loadingNotes && notes.length > 0 && (
      <div className="bg-white rounded shadow-md w-full lg:w-[calc(33.333%-1rem)] lg:flex-none h-[400px] overflow-y-auto p-3">
          <Table arial-label="Default table">
            <TableHeader style={{ height: "50px" }}>
              <TableRow>
                  <TableHeaderCell>
                      <Subtitle1>Loggboksanteckningar</Subtitle1>
                  </TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {/* loadingNotes ? (
                <TableRow>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex justify-center items-center py-8">
                        <Spinner label="Laddar anteckningar..." />
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ) : */ notes.map(item => (
                <TableRow onClick={() => openTenderDrawer(item.noteModuleID)} className='cursor-pointer' key={item.noteID}>
                  <TableCell>
                    <TableCellLayout>
                      <div className="flex items-center justify-between">
                          <div className='flex flex-col'>
                              <Text weight='bold'>{item.noteHeader}</Text>
                              <Text>{getNoteTenderAndTendering(item.noteModuleID)}</Text>
                          </div>
                      </div>
                    </TableCellLayout>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
          )}
        </div>  
      </div>
      {selectedNews && <NewsDialog isOpen={newsDialogOpen} onClose={() => {setNewsDialogOpen(false); setSelectedNews(undefined);}} news={selectedNews}/>}
      {selectedTender && <TenderSettingsDrawer 
          open={isTenderDrawerOpen}
          onClose={() => {setIsTenderDrawerOpen(false); setSelectedTender(undefined);}}
          partialTender={selectedTender}
          tab="logs"
        />}
    </>
  );
};

export default StartComponent;